import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '@api/auth';
import { HttpError } from '@api/http';

export default function BootstrapSuperAdminPage(): JSX.Element {
  const navigate = useNavigate();
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  return (
    <div className="flex min-h-full items-center justify-center bg-bg px-4 py-10">
      <form
        className="w-full max-w-lg rounded-lg border border-border bg-surface p-6 shadow-card"
        onSubmit={(e) => {
          e.preventDefault();
          setBusy(true);
          setError(null);
          setSuccess(null);
          authApi
            .bootstrapSuperAdmin({ fullName, email, password })
            .then(() => {
              setSuccess('Super admin created. You can now sign in.');
              setTimeout(() => navigate('/login', { replace: true }), 1200);
            })
            .catch((err: unknown) => {
              const message =
                err instanceof HttpError
                  ? err.message
                  : err instanceof Error
                    ? err.message
                    : 'Failed to bootstrap super admin';
              setError(message);
            })
            .finally(() => setBusy(false));
        }}
      >
        <h1 className="text-xl font-semibold text-foreground">Bootstrap super admin</h1>
        <p className="mt-1 text-sm text-muted">
          Run this only once on a fresh environment.
        </p>

        <div className="mt-5 space-y-3">
          <label className="block text-sm">
            <span className="mb-1 block text-muted">Full name</span>
            <input
              className="w-full rounded-md border border-border bg-bg px-3 py-2 outline-none focus:border-accent"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
            />
          </label>
          <label className="block text-sm">
            <span className="mb-1 block text-muted">Email</span>
            <input
              className="w-full rounded-md border border-border bg-bg px-3 py-2 outline-none focus:border-accent"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label className="block text-sm">
            <span className="mb-1 block text-muted">Password</span>
            <input
              className="w-full rounded-md border border-border bg-bg px-3 py-2 outline-none focus:border-accent"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
            />
          </label>
        </div>

        {error ? <p className="mt-3 text-sm text-danger">{error}</p> : null}
        {success ? <p className="mt-3 text-sm text-success">{success}</p> : null}

        <button
          type="submit"
          disabled={busy}
          className="mt-5 w-full rounded-md bg-accent px-3 py-2 text-sm font-semibold text-white disabled:opacity-60"
        >
          {busy ? 'Creating...' : 'Create super admin'}
        </button>
      </form>
    </div>
  );
}
